import React, { useState } from 'react';
import './App.css';
import WorldMap from './components/Map/WorldMap';
import InfoBox from './components/InfoBox/InfoBox';
import Statistics from './components/Statistics/Statistics';

const App = () => {
  const [selectedCountry, setSelectedCountry] = useState(null);

  const handleSelectCountry = (country) => {
    setSelectedCountry(country.properties);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Jose M Munoz Travel Tracker</h1>
        <p>"LIVE YOUR LIFE BY A COMPASS, NOT A CLOCK." ~E. Jong</p>
      </header>
      <div className="content">
        <Statistics />
        <div className="map-container">
          <WorldMap onSelectCountry={handleSelectCountry} />
          <InfoBox selectedCountry={selectedCountry} />
        </div>
      </div>
    </div>
  );
};

export default App;
